import type { RouteLocationNormalizedLoaded } from 'vue-router'
import { entryMatchDepth, type NavCatalogEntry } from './navCatalog'

/**
 * The sidebar link to highlight for the current page: the most specific match, so a "Time Card
 * Editor" link wins over the Attendance hub on the editor itself. Ties go to whichever comes
 * first in the sidebar. Null when the page is not in the sidebar at all -- nothing is highlighted
 * rather than something approximately right.
 */
export function pickActiveLinkId (
  links: Iterable<{ id: string, entry: NavCatalogEntry }>,
  route: RouteLocationNormalizedLoaded
): string | null {
  let bestId: string | null = null
  let bestDepth = -1
  for (const link of links) {
    const depth = entryMatchDepth(link.entry, route)
    if (depth > bestDepth) {
      bestDepth = depth
      bestId = link.id
    }
  }
  return bestId
}
